import React from "react";
import { Button, Form, Spinner, Table } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";
import { formatDate } from "../breakfastUtils";

const BreakfastTable = ({
  rows,
  loading,
  pageSummary,
  page,
  totalPages,
  onPageChange,
  onEdit,
  onStatusChange,
}) => {
  return (
    <div className="card admin-surface-card">
      <div className="card-header admin-surface-header d-flex justify-content-between align-items-center flex-wrap gap-2">
        <small className="text-muted">{pageSummary}</small>
      </div>

      <div className="card-body admin-surface-body p-0">
        <div className="table-responsive">
          <Table hover className="mb-0 align-middle">
            <thead>
              <tr>
                <th>Property</th>
                <th>Room Type</th>
                <th>Breakfast Charge</th>
                <th>Effective From</th>
                <th>Status</th>
                <th className="text-center">Actions</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="text-center py-5">
                    <Spinner size="sm" className="me-2" />
                    Loading configurations...
                  </td>
                </tr>
              ) : rows.length ? (
                rows.map((row) => (
                  <tr key={row.intID}>
                    <td>
                      <div className="fw-semibold">{row.propertyName}</div>
                    </td>

                    <td>
                      <div>{row.roomType}</div>
                    </td>

                    <td>
                      <span className="fw-bold text-dark fs-6">
                        ₹{Number(row.BreakfastCharge || 0).toFixed(2)}
                      </span>
                    </td>

                    <td>{formatDate(row.dtmEffectiveFrom)}</td>

                    <td>
                      <span
                        className={`badge d-inline-flex align-items-center gap-1 px-2 py-1 ${
                          row.bitStatus ? "bg-success" : "bg-danger"
                        }`}
                        style={{
                          boxShadow: row.bitStatus
                            ? "0 0 8px rgba(25, 135, 84, 0.35)"
                            : "0 0 8px rgba(220, 53, 69, 0.35)",
                        }}
                      >
                        <span
                          style={{
                            width: "6px",
                            height: "6px",
                            borderRadius: "50%",
                            backgroundColor: "#fff",
                            display: "inline-block",
                          }}
                        />
                        {row.bitStatus ? "Active" : "Inactive"}
                      </span>
                    </td>

                    <td>
                      <div className="d-flex justify-content-center align-items-center gap-2">
                        <Button
                          size="sm"
                          variant="outline-primary"
                          onClick={() => onEdit(row)}
                          title="Edit"
                        >
                          <FaEdit />
                        </Button>

                        <Form.Check
                          type="switch"
                          id={`status-switch-${row.intID}`}
                          checked={Boolean(row.bitStatus)}
                          onChange={() => onStatusChange(row)}
                          title={row.bitStatus ? "Deactivate" : "Enable"}
                          className="mb-0 fs-5"
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center text-muted py-5">
                    No breakfast configurations found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {totalPages > 1 && (
        <div className="card-footer bg-white d-flex justify-content-end gap-2">
          <Button
            size="sm"
            variant="outline-secondary"
            disabled={page === 1 || loading}
            onClick={() => onPageChange(page - 1)}
          >
            Previous
          </Button>
          <span className="align-self-center small">
            Page {page} of {totalPages}
          </span>
          <Button
            size="sm"
            variant="outline-secondary"
            disabled={page === totalPages || loading}
            onClick={() => onPageChange(page + 1)}
          >
            Next
          </Button>
        </div>
      )}
    </div>
  );
};

export default BreakfastTable;
